import RichText from "@/components/RichText";
import { resolveButtonStyle } from "@/lib/ctaButtonStyle";
import CtaButtonBlocks, { ctaButtonBlocks } from "./CtaButtonBlocks";

// Proche d'ImageBannerSection.jsx mais sans image obligatoire — un simple
// fond de couleur (background_color) porte le message promotionnel.
const DEFAULTS = {
  heading: "Offre limitée",
  body: "",
  cta_label: "En profiter",
  cta_url: "/boutique",
  background_color: "#0A0E17",
  // Optionnels (Sprint 12) — vides par défaut, comportement d'origine
  // inchangé (pas de pastille eyebrow ni de second lien).
  eyebrow: "",
  cta_secondary_label: "",
  cta_secondary_url: "",
};

export default function PromoBannerSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const ctaStyle = resolveButtonStyle(t, "cta");
  const extraButtons = ctaButtonBlocks(blocks);
  const secondaryStyle = resolveButtonStyle(t, "cta_secondary");
  // Le bouton secondaire est en "contour" (fond transparent) — une couleur
  // choisie ici recolore le contour/texte plutôt que de remplir le fond,
  // pour ne pas lui faire perdre son identité visuelle de second choix.
  const secondaryStyleProps = { ...secondaryStyle.style };
  if (secondaryStyleProps.backgroundColor) {
    secondaryStyleProps.borderColor = secondaryStyleProps.backgroundColor;
    secondaryStyleProps.color = secondaryStyleProps.backgroundColor;
    delete secondaryStyleProps.backgroundColor;
  }

  return (
    <section className="px-6" style={{ background: t.background_color }}>
      <div className="max-w-[1240px] mx-auto py-14 md:py-16 flex flex-col items-center text-center gap-4">
        {t.eyebrow && (
          <RichText
            as="span"
            className="inline-flex items-center gap-1.5 rounded-full border border-white/20 px-3.5 py-1.5 text-[12px] font-semibold tracking-wide text-white/80 uppercase"
            html={t.eyebrow}
          />
        )}
        <RichText
          as="h2"
          className="font-display font-semibold text-[26px] md:text-[32px] leading-tight tracking-[-0.02em] text-white"
          html={t.heading}
        />
        {t.body && (
          <RichText as="p" preserveParagraphs className="text-[15px] text-white/85 max-w-lg" html={t.body} />
        )}
        {(t.cta_label || t.cta_secondary_label || extraButtons.length > 0) && (
          <div className="flex flex-wrap items-center justify-center gap-4 mt-2">
            {t.cta_label && (
              <a
                href={t.cta_url || "#"}
                className={`inline-flex items-center gap-2 bg-white text-ink px-7 py-3 text-[14px] font-semibold hover:opacity-90 transition-opacity ${ctaStyle.className}`}
                style={ctaStyle.style}
                aria-label={!ctaStyle.showText ? t.cta_label : undefined}
              >
                {ctaStyle.showIcon && ctaStyle.Icon && <ctaStyle.Icon className="h-4 w-4" />}
                {ctaStyle.showText && t.cta_label}
              </a>
            )}
            {t.cta_secondary_label && (
              <a
                href={t.cta_secondary_url || "#"}
                className={`inline-flex items-center gap-2 border border-white/25 text-white px-7 py-3 text-[14px] font-semibold hover:bg-white/10 transition-colors ${secondaryStyle.className}`}
                style={secondaryStyleProps}
                aria-label={!secondaryStyle.showText ? t.cta_secondary_label : undefined}
              >
                {secondaryStyle.showIcon && secondaryStyle.Icon && <secondaryStyle.Icon className="h-4 w-4" />}
                {secondaryStyle.showText && t.cta_secondary_label}
              </a>
            )}
            <CtaButtonBlocks blocks={blocks} tone="dark" size="sm" />
          </div>
        )}
      </div>
    </section>
  );
}
